<div class="product-detail">
  <nav aria-label="breadcrumb">
    <!-- <ol class="breadcrumb ol-brd" style="background-color:transparent;">
      <li class="breadcrumb-item"><a href="javascript:void(0)">Home</a></li>
      <li class="breadcrumb-item"><a href="javascript:void(0)" (click)="bread()">Catalogue</a></li>
      <li class="breadcrumb-item active" aria-current="page">Product</li>
    </ol> -->
  </nav>
  <div class="mb-rs-product-container" style="padding:0 15px; text-align:left;">
      <app-detail #subsummary [setComponentId]="componentId"></app-detail>
  </div>
</div>